import { imageStrings } from './icons';
import { Profession } from '@/enums/profession';
import type { StaticDataCurrencyCategory } from '@/shared/stores/static/types';
import { Constants } from './constants';

export const categoryOrder: number[] = [
    264, // Midnight
    260, // War Within
    250, // Dragonflight
    245, // Shadowlands
    143, // Battle for Azeroth
    141, // Legion
    137, // Warlords of Draenor
    133, // Mists of Pandaria
    81, // Cataclysm
    21, // Wrath of the Lich King
    23, // Burning Crusade
    //4, // Classic
    0, // separator
    22, // Dungeon and Raid
    1, // Miscellaneous
    2, // Player vs. Player
];

export const categoryChildren: Record<number, StaticDataCurrencyCategory[]> = {
    // Miscellaneous
    1: [
        {
            id: 100104,
            name: 'Decor',
            slug: 'decor',
        },
        {
            id: 100101,
            name: 'Pet Battles',
            slug: 'pet-battles',
        },
        {
            id: 100102,
            name: 'World Events',
            slug: 'world-events',
        },
    ],

    // Midnight
    264: [
        {
            id: 283,
            name: 'Zones',
            slug: 'zones',
        },
        {
            id: 126411,
            name: 'Season 1',
            slug: 'season-1',
        },
        {
            id: 126412,
            name: 'Season 2',
            slug: 'season-2',
        },
        null,
        {
            id: 126401,
            name: 'Crafting Concentration',
            slug: 'crafting-concentration',
        },
        {
            id: 126402,
            name: 'Crafting Knowledge',
            slug: 'crafting-knowledge',
        },
        {
            id: 126403,
            name: 'Crafting Moxie',
            slug: 'crafting-moxie',
        },
        {
            id: 126404,
            name: 'Crafting Catchup',
            slug: 'crafting-catchup',
        },
    ],

    // The War Within
    260: [
        {
            id: 126001,
            name: 'Crafting Concentration',
            slug: 'crafting-concentration',
        },
        {
            id: 126002,
            name: 'Crafting Knowledge',
            slug: 'crafting-knowledge',
        },
        {
            id: 126011,
            name: 'Season 1',
            slug: 'season-1',
        },
        {
            id: 126012,
            name: 'Season 2',
            slug: 'season-2',
        },
        {
            id: 126013,
            name: 'Season 3',
            slug: 'season-3',
        },
    ],

    // Dragonflight
    250: [
        {
            id: 125001,
            name: 'Crafting Knowledge',
            slug: 'crafting-knowledge',
        },
        {
            id: 125002,
            name: 'Crafting Materials',
            slug: 'crafting-materials',
        },
        {
            id: 125011,
            name: 'Season 1',
            slug: 'season-1',
        },
        {
            id: 125012,
            name: 'Season 2',
            slug: 'season-2',
        },
        {
            id: 125013,
            name: 'Season 3',
            slug: 'season-3',
        },
        {
            id: 125014,
            name: 'Season 4',
            slug: 'season-4',
        },
    ],
};

export const currencyExtra: Record<number, number[]> = {
    264: [
        3405, // Field Accolade
        3393, // Illusionary Coin
        3392, // Remnant of Anguish
    ],
    // Midnight - Crafting Concentration
    126401: [
        3161, // Alchemy,
        3162, // Blacksmithing,
        3163, // Enchanting,
        3164, // Engineering,
        3165, // Inscription,
        3166, // Jewelcrafting,
        3167, // Leatherworking,
        3168, // Tailoring,
    ],
    // Midnight - Crafting Knowledge
    126402: [
        3150, // Alchemy
        3151, // Blacksmithing
        3152, // Enchanting
        3153, // Engineering
        3155, // Inscription
        3156, // Jewelcrafting
        3157, // Leatherworking
        3160, // Tailoring
        3154, // Herbalism
        3158, // Mining
        3159, // Skinning
    ],
    // Midnight - Crafting Moxie
    126403: [
        3256, // Alchemy
        3257, // Blacksmithing
        3258, // Enchanting
        3259, // Engineering
        3261, // Inscription
        3262, // Jewelcrafting
        3263, // Leatherworking
        3266, // Tailoring
        3260, // Herbalism
        3264, // Mining
        3265, // Skinning
    ],
    // Midnight - Crafting Catchup
    126404: [
        3189, // Alchemy
        3199, // Blacksmithing
        3198, // Enchanting
        3197, // Engineering
        3195, // Inscription
        3194, // Jewelcrafting
        3193, // Leatherworking
        3190, // Tailoring
        3196, // Herbalism
        3192, // Mining
        3191, // Skinning
    ],
    // Midnight - Season 1
    126411: [
        3418, // Nebulous Voidcore
        null,
        3378, // Dawnlight Manaflux
        3212, // Radiant Spark Dust (spark tracker)
    ],
    // Midnight - Season 2
    126412: [
        3310, // Coffer Key Shards
        3028, // Restored Coffer Key
        2803, // Undercoin
        3356, // Untainted Mana-Crystals
        3418, // Nebulous Voidcore
        null,
        3442, // Adventurer Mistcrest
        3443, // Veteran Mistcrest
        3444, // Champion Mistcrest
        3445, // Hero Mistcrest
        3446, // Myth Mistcrest
        null,
        3465, // Venomblight Manaflux
        3509, // Tidal Spark Dust (spark tracker)
    ],
    // The War Within - Crafting Concentration
    126001: [
        3045, // Alchemy
        3040, // Blacksmithing
        3046, // Enchanting
        3044, // Engineering
        3043, // Inscription
        3013, // Jewelcrafting
        3042, // Leatherworking
        3041, // Tailoring
    ],
    // The War Within - Crafting Knowledge
    126002: [
        2785, // Alchemy Knowledge
        2786, // Blacksmithing Knowledge
        2787, // Enchanting Knowledge
        2788, // Engineering Knowledge
        2789, // Herbalism Knowledge
        2790, // Inscription Knowledge
        2791, // Jewelcrafting Knowledge
        2792, // Leatherworking Knowledge
        2793, // Mining Knowledge
        2794, // Skinning Knowledge
        2795, // Tailoring Knowledge
    ],
    // The War Within - Season 1
    126011: [
        2813, // Harmonized Silk
    ],
    // The War Within - Season 2
    126012: [
        3116, // Essence of Kaja'mite
    ],
    // The War Within - Season 3
    126013: [
        3269, // Ethereal Voidsplinter
    ],

    // Dragonflight
    250: [
        // 1191, // Valor
        // 2167, // Catalyst Charges
    ],
    // Dragonflight - Crafting Knowledge
    125001: [
        2024, // Alchemy Knowledge
        2023, // Blacksmithing Knowledge
        2030, // Enchanting Knowledge
        2027, // Engineering Knowledge
        2034, // Herbalism Knowledge
        2028, // Inscription Knowledge
        2029, // Jewelcrafting Knowledge
        2025, // Leatherworking Knowledge
        2035, // Mining Knowledge
        2033, // Skinning Knowledge
        2026, // Tailoring Knowledge
    ],
    // Dragonflight - Season 2
    125012: [
        2533, // Renascent Shadowflame
    ],
    // Dragonflight - Season 3
    125013: [
        2796, // Renascent Dream
        2797, // Trophy of Strife
    ],
    // Dragonflight - Season 4
    125014: [
        2245, // Flightstones
        2912, // Renascent Awakening
    ],
    // Miscellaneous > World Events
    100102: [
        3309, // Hellstone Shard
    ],
    // Miscellaneous > Decor
    100104: [
        3363, // Community Coupons
    ],
};

export const currencyItems: Record<number, number[]> = {
    // Burning Crusade
    23: [
        26045, // Halaa Battle Token
        26044, // Halaa Research Token
    ],

    // Warlords of Draenor
    137: [
        124099, // Blackfang Claw
    ],

    // Legion
    141: [
        124124, // Blood of Sargeras
        146963, // Desecrated Seaweed
        153021, // Intact Demon Eye
    ],

    // Battle for Azeroth
    143: [
        152668, // Expulsom
        162460, // Hydrocore
        165948, // Tidalcore
        168802, // Nazjatar Battle Commendation
    ],

    // Shadowlands
    245: [
        188957, // Genesis Mote
        190189, // Sandworn Relic
    ],

    // Dragonflight
    250: [
        211376, // Seedbloom
        208066, // Small Dreamseed
        208067, // Plump Dreamseed
        208047, // Gigantic Dreamseed
        null,
        207026, // Dreamsurge Coalescence
        210254, // Dreamsurge Cocoon
        null,
        209856, // Dilated Time Pod
        207002, // Encapsulated Destiny
        null,
        204715, // Unearthed Fragrant Coin
        204727, // Coveted Bauble
        204985, // Barter Brick
        205188, // Barter Boulder
        null,
        204276, // Untapped Forbidden Knowledge
        202196, // Zskera Vault Key
    ],
    // Dragonflight > Crafting Knowledge
    125001: [
        191784, // Dragon Shard of Knowledge [DF]
    ],
    // Dragonflight > Crafting Materials
    125002: [
        190456, // Artisan's Mettle
        198048, // Titan Training Matrix I
        198056, // Titan Training Matrix II
        198058, // Titan Training Matrix III
        198059, // Titan Training Matrix IV
        204673, // Titan Training Matrix V
    ],
    // Dragonflight > Season 1
    125011: [
        201836, // Aspects' Token of Merit
        199197, // Bottled Essence
        190453, // Spark of Ingenuity
        null,
        200686, // Primal Focus
        197921, // Primal Infusion
        190455, // Concentrated Primal Focus
        198046, // Concentrated Primal Infusion
    ],
    // Dragonflight > Season 2
    125012: [
        204717, // Splintered Spark of Shadowflame
        204440, // Spark of Shadowflame
        205225, // Aspects' Token of Merit
    ],
    // Dragonflight > Season 3
    125013: [
        208396, // Splintered Spark of Dreams
        206959, // Spark of Dreams
    ],
    // Dragonflight > Season 4
    125014: [
        211515, // Splintered Spark of Awakening
        211516, // Spark of Awakening
        213089, // Antique Bronze Bullion
    ],

    // The War Within
    260: [
        210814, // Artisan's Acuity
        223951, // Earth-Encrusted Gem
        212493, // Odd Glob of Wax
        206350, // Radiant Remnant
        null,
        224025, // Crackling Shard
        246240, // Devoured Energy-Pod
        null,
        233246, // Gunk-Covered Thingy
        234741, // Miscellaneous Mechanica
        238920, // Radiant Emblem of Service
    ],
    // The War Within - Season 1
    126011: [
        211297, // Fractured Spark of Omens
        211296, // Spark of Omens
    ],
    // The War Within - Season 2
    126012: [
        237578, // Counterfeit Dealer's Chip
        230905, // Fractured Spark of Fortunes
        230906, // Spark of Fortunes
    ],
    // The War Within - Season 3
    126013: [
        246771, // Radiant Echo
        231757, // Fractured Spark of Starlight
        231756, // Spark of Starlight
    ],

    // Midnight
    264: [
        264882, // Finery Funds
        255826, // Mysterious Skyshards
        245345, // Fused Vitality
        null,
        242241, // Latent Arcana
        246951, // Stormarion Core
        null,
        267051, // Dark Particle
        null,
        285801, // Heroic Soul Fragment
        285065, // Mythical Soul Fragment
    ],
    // Midnight - Zones
    283: [
        273000, // Corrosive Soul
        279382, // Venom-Cursed Fragment
    ],
    // Midnight - Season 1
    126411: [
        232875, // Spark of Radiance
    ],
    // Midnight - Season 2
    126412: [
        274476, // Spark of Tides
        280562, // Ascendant Venomstone
        269862, // Thalassian Token of Merit
        null,
        276547, // Afflicted Soul
        276548, // Tormented Soul
        274422, // Ossified Relic
    ],

    // Player vs Player
    2: [
        137642, // Mark of Honor
    ],

    // Miscellaneous
    // 1: [],
    // Miscellaneous > Pet Battles
    100101: [
        86143, // Battle Pet Bandage
        98112, // Lesser Pet Treat
        98114, // Pet Treat
        163036, // Polished Pet Charm
        null,
        92741, // Flawless Battle-Stone
        98715, // Marked Flawless Battle-Stone
        92679, // Flawless Aquatic Battle-Stone
        92675, // Flawless Beast Battle-Stone
        92676, // Flawless Critter Battle-Stone
        92683, // Flawless Dragonkin Battle-Stone
        92665, // Flawless Elemental Battle-Stone
        92677, // Flawless Flying Battle-Stone
        92682, // Flawless Humanoid Battle-Stone
        92678, // Flawless Magic Battle-Stone
        92680, // Flawless Mechanical Battle-Stone
        92681, // Flawless Undead Battle-Stone
        null,
        122457, // Ultimate Battle-Training Stone
        127755, // Fel-Touched Battle-Training Stone
        116424, // Aquatic Battle-Training Stone
        116374, // Beast Battle-Training Stone
        116418, // Critter Battle-Training Stone
        116419, // Dragonkin Battle-Training Stone
        116420, // Elemental Battle-Training Stone
        116421, // Flying Battle-Training Stone
        116416, // Humanoid Battle-Training Stone
        116422, // Magic Battle-Training Stone
        116417, // Mechanical Battle-Training Stone
        116423, // Undead Battle-Training Stone
    ],
    // Miscellaneous > World Events
    100102: [
        37829, // Brewfest Prize Token
        23247, // Burning Blossom
        21100, // Coin of Ancestry
        49927, // Love Token
        44791, // Noblegarden Chocolate
        33226, // Tricky Treat
        null,
        231510, // Timewarped Relic Coffer Key [LFR]
        232365, // Timewarped Relic Coffer Key [Normal]
        232366, // Timewarped Relic Coffer Key [Heroic]
    ],
    // Miscellaneous > Decor
    100104: [
        269010, // Essence of Lumber
        245586, // Ironwood Lumber [Classic]
        242691, // Olemba Lumber [TBC]
        251762, // Coldwind Lumber [WotLK]
        251764, // Ashwood Lumber [Cata]
        251763, // Bamboo Lumber [MoP]
        251766, // Shadowmoon Lumber [WoD]
        251767, // Fel-Touched Lumber [Legion]
        251768, // Darkpine Lumber [BfA]
        251772, // Arden Lumber [SL]
        251773, // Dragonpine Lumber [DF]
        248012, // Dornic Fir Lumber [TWW]
        256963, // Thalssian Lumber [MN]
    ],
};

export const currencyItemCurrencies: Record<number, number> = {
    204075: 2409, // Whelpling Crest Fragment
    204076: 2410, // Drake Crest Fragment
    204077: 2411, // Wyrm Crest Fragment
    204078: 2412, // Aspect Crest Fragment

    213089: 3010, // Antique Bronze Bullion

    211297: 3023, // Fractured Spark of Omens
    230905: 3132, // Fractured Spark of Fortunes

    231510: 3144, // Timewarped Relic Coffer Key [LFR]
    232365: 3145, // Timewarped Relic Coffer Key [N]
    232366: 3146, // Timewarped Relic Coffer Key [H]
};

export const currencyProfession: Record<number, number> = {
    // Midnight - Crafting Concentration
    3161: Profession.Alchemy,
    3162: Profession.Blacksmithing,
    3163: Profession.Enchanting,
    3164: Profession.Engineering,
    3165: Profession.Inscription,
    3166: Profession.Jewelcrafting,
    3167: Profession.Leatherworking,
    3168: Profession.Tailoring,

    // Midnight - Crafting Moxie
    3256: Profession.Alchemy,
    3257: Profession.Blacksmithing,
    3258: Profession.Enchanting,
    3259: Profession.Engineering,
    3260: Profession.Herbalism,
    3261: Profession.Inscription,
    3262: Profession.Jewelcrafting,
    3263: Profession.Leatherworking,
    3264: Profession.Mining,
    3265: Profession.Skinning,
    3266: Profession.Tailoring,

    // Midnight - Crafting Catchup
    3189: Profession.Alchemy,
    3199: Profession.Blacksmithing,
    3198: Profession.Enchanting,
    3197: Profession.Engineering,
    3196: Profession.Herbalism,
    3195: Profession.Inscription,
    3194: Profession.Jewelcrafting,
    3193: Profession.Leatherworking,
    3192: Profession.Mining,
    3191: Profession.Skinning,
    3190: Profession.Tailoring,

    // The War Within - Crafting Concentration
    3045: Profession.Alchemy,
    3040: Profession.Blacksmithing,
    3046: Profession.Enchanting,
    3044: Profession.Engineering,
    3043: Profession.Inscription,
    3013: Profession.Jewelcrafting,
    3042: Profession.Leatherworking,
    3041: Profession.Tailoring,
};

export const currencyIconOverride: Record<number, string> = {
    // Midnight - Crafting Concentration
    3161: imageStrings['alchemy'],
    3162: imageStrings['blacksmithing'],
    3163: imageStrings['enchanting'],
    3164: imageStrings['engineering'],
    3165: imageStrings['inscription'],
    3166: imageStrings['jewelcrafting'],
    3167: imageStrings['leatherworking'],
    3168: imageStrings['tailoring'],

    // Midnight - Crafting Moxie
    3256: imageStrings['alchemy'],
    3257: imageStrings['blacksmithing'],
    3258: imageStrings['enchanting'],
    3259: imageStrings['engineering'],
    3260: imageStrings['herbalism'],
    3261: imageStrings['inscription'],
    3262: imageStrings['jewelcrafting'],
    3263: imageStrings['leatherworking'],
    3264: imageStrings['mining'],
    3265: imageStrings['skinning'],
    3266: imageStrings['tailoring'],

    // Midnight - Crafting Catchup
    3189: imageStrings['alchemy'],
    3199: imageStrings['blacksmithing'],
    3198: imageStrings['enchanting'],
    3197: imageStrings['engineering'],
    3196: imageStrings['herbalism'],
    3195: imageStrings['inscription'],
    3194: imageStrings['jewelcrafting'],
    3193: imageStrings['leatherworking'],
    3192: imageStrings['mining'],
    3191: imageStrings['skinning'],
    3190: imageStrings['tailoring'],

    // The War Within - Crafting Concentration
    3045: imageStrings['alchemy'],
    3040: imageStrings['blacksmithing'],
    3046: imageStrings['enchanting'],
    3044: imageStrings['engineering'],
    3043: imageStrings['inscription'],
    3013: imageStrings['jewelcrafting'],
    3042: imageStrings['leatherworking'],
    3041: imageStrings['tailoring'],
};

export const currencyShowRemaining = new Set<number>([
    3189, // Alchemy
    3199, // Blacksmithing
    3198, // Enchanting
    3197, // Engineering
    3196, // Herbalism
    3195, // Inscription
    3194, // Jewelcrafting
    3193, // Leatherworking
    3192, // Mining
    3191, // Skinning
    3190, // Tailoring
]);

export const currencyText: Record<number, string> = {
    1_245586: 'Cla', // Ironwood Lumber [Classic]
    1_242691: 'TBC', // Olemba Lumber [TBC]
    1_251762: 'WotLK', // Coldwind Lumber [WotLK]
    1_251764: 'Cata', // Ashwood Lumber [Cata]
    1_251763: 'MoP', // Bamboo Lumber [MoP]
    1_251766: 'WoD', // Shadowmoon Lumber [WoD]
    1_251767: 'Leg', // Fel-Touched Lumber [Legion]
    1_251768: 'BfA', // Darkpine Lumber [BfA]
    1_251772: 'SL', // Arden Lumber [SL]
    1_251773: 'DF', // Dragonpine Lumber [DF]
    1_248012: 'TWW', // Dornic Fir Lumber [TWW]
    1_256963: 'Mid', // Thalssian Lumber [Mid]
};

const skipCurrencies: number[] = [
    // Midnight
    3256, // Alchemy
    3257, // Blacksmithing
    3258, // Enchanting
    3259, // Engineering
    3260, // Herbalism
    3261, // Inscription
    3262, // Jewelcrafting
    3263, // Leatherworking
    3264, // Mining
    3265, // Skinning
    3266, // Tailoring
    3319, // Twilight's Blade Insignia
    3349, // [DNT][PH]
    3394, // Latent Arcana

    // The War Within
    2914, // Weathered Harbinger Crest
    2915, // Carved Harbinger Crest
    2916, // Runed Harbinger Crest
    2917, // Gilded Harbinger Crest

    // Dragonflight
    2651, // Seedbloom
    2706, // Whelpling's Dreaming Crests
    2707, // Drake's Dreaming Crests
    2708, // Wyrm's Dreaming Crests
    2709, // Aspect's Dreaming Crests
    2806, // Whelpling's Awakened Crest
    2807, // Drake's Awakened Crest
    2809, // Wyrm's Awakened Crest
    2812, // Aspect's Awakened Crest

    // Warlords of Draenor
    897, // UNUSED

    // Legion
    1355, // Felessence
    1356, // Echoes of Battle
    1357, // Echoes of Domination

    // Battle for Azeroth
    1587, // War Supplies

    // Shadowlands
    1743, // Fake Anima for Quest Tracking
    1754, // Argent Commendation??
    1802, // Shadowlands PvP Weekly Reward Progress
    1811, // zzoldSanctum Architect
    1812, // zzoldSanctum Anima Weaver
    1829, // Renown-Kyrian
    1830, // Renown-Venthyr
    1831, // Renown-Night Fae
    1832, // Renown-Necrolord
    1859, // Reservoir Anima-Kyrian
    1860, // Reservoir Anima-Venthyr
    1861, // Reservoir Anima-Night Fae
    1862, // Reservoir Anima-Necrolord
    1863, // Redeemed Soul-Kyrian
    1864, // Redeemed Soul-Venthyr
    1865, // Redeemed Soul-Night Fae
    1866, // Redeemed Soul-Necrolord
    1867, // Sanctum Architect-Kyrian
    1868, // Sanctum Architect-Venthyr
    1869, // Sanctum Architect-Night Fae
    1870, // Sanctum Architect-Necrolord
    1871, // Sanctum Anima Weaver-Kyrian
    1872, // Sanctum Anima Weaver-Venthyr
    1873, // Sanctum Anima Weaver-Night Fae
    1874, // Sanctum Anima Weaver-Necrolord

    // Dragonflight
    2045, // Dragon Glyph Embers
    2073, // [AC] Major Faction Test Currency

    // Miscellaneous
    1, // Currency Token Test Token 4
    2, // Currency Token Test Token 2
    4, // Currency Token Test Token 5
    42, // Badge of Justice
    1388, // Armor Scraps
    1835, // Linked Currency Test (Src) - PTH
    1836, // Linked Currency Test (Dst) - PTH
    2005, // Druid Talent Points (DNT)
    2006, // Restoration Talent Points (DNT)
    2011, // Effigy Adornments
    2012, // Death Knight Talent Points (DNT)
    2013, // Frost Talent Points (DNT)
    2014, // Unholy Talent Points (DNT)
    2015, // Blood Talent Points (DNT)
    2032, // Trader's Tender

    // Player vs. Player
    103, // Arena Points
    104, // Honor Points DEPRECATED
    161, // Stone Keeper's Shard
    181, // Honor Points DEPRECATED2
    201, // Venture Coin
];

export const skipCurrenciesMap: Record<number, boolean> = Object.fromEntries(
    skipCurrencies.map((currencyId) => [currencyId, true])
);

export const pvpCurrencies = new Set<number>([
    1356, // Echoes of Battle
    1602, // Conquest
    1792, // Honor
    2123, // Bloody Tokens
    1137642, // Mark of Honor
]);

export const currencyGood: Record<number, number> = {
    [Constants.currencies.honor]: 2000,

    1279382: 2, // Venom-Cursed Fragment

    // Midnight - Crafting Moxie
    3256: 600, // Alchemy
    3257: 600, // Blacksmithing
    3258: 600, // Enchanting
    3259: 600, // Engineering
    3260: 600, // Herbalism
    3261: 600, // Inscription
    3262: 600, // Jewelcrafting
    3263: 600, // Leatherworking
    3264: 600, // Mining
    3265: 600, // Skinning
    3266: 600, // Tailoring
};
